// extracted by mini-css-extract-plugin
export default {"header":"Header_header__gdN3I","headerBackground":"Header_headerBackground__cp6co"};